import { TableCard } from '../../../../components'
import { ClientesListHeader } from './components/header/ClientesListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { ListViewProvider } from './core/ListViewProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { ClientesTable } from './table/ClientesTable'

const ClientesList = () => {
  return (
    <TableCard>
      <ClientesListHeader />
      <ClientesTable />
    </TableCard>
  )
}

export const ClientesListWrapper = () => (
  <ListFiltersProvider>
    <QueryRequestProvider>
      <QueryResponseProvider>
        <ListViewProvider>
          <ClientesList />
        </ListViewProvider>
      </QueryResponseProvider>
    </QueryRequestProvider>
  </ListFiltersProvider>
)
